import { ErrorCode } from '@telialt/models/src/ErrorModelMS';
import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { MS_URL } from '@telialt/utils/src/microservices';

import { Channel, OfferGroup } from './model';

export const API = {
    URL_PUBLIC_SERVICE_OFFERS: `${MS_URL}/api/v3/offers/{segment}/service-offers/catalog`,
    URL_SELF_SERVICE_SERVICE_OFFERS: `${MS_URL}/api/v3/offers/{segment}/service-offers/personal`,
    URL_POST_CHECKOUT_CART: `${MS_URL}/api/v3/carts/{segment}/carts`,
    URL_MARKETING_CONSENT: `${MS_URL}/api/v3/customers/{segment}/consents/marketing-consent`,
    URL_SAVE_MARKETING_CONSENTS: '/api/v2/{segment}/my/right-to-objects/duomenys-tiesioginiams-pasiulymams',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.URL_PUBLIC_SERVICE_OFFERS = '/api/plans/public-service-offers';
    API.URL_SELF_SERVICE_SERVICE_OFFERS = '/api/plans/self-service-service-offers';
    API.URL_POST_CHECKOUT_CART = `/api/eshop/checkout/auto-order/create-cart`;
    API.URL_MARKETING_CONSENT = '/api/self-service/consents/marketing-consents';
    API.URL_SAVE_MARKETING_CONSENTS = '/api/self-service/consents/update';
}

export const QUERY_KEYS = {
    PUBLIC_SERVICE_OFFERS: 'public-service-offers',
    SELF_SERVICE_SERVICE_OFFERS: 'self-service-service-offers',
    MARKETING_CONSENT: 'marketing-consent',
};

export const MUTATION_KEYS = {
    CREATE_CHECKOUT_CART: 'create-checkout-cart',
    ACCEPT_MARKETING_CONSENT: 'accept-marketing-consent',
};

export const PLANS_TEST_ID = {
    CAMPAIGN_BUTTON: 'plans-campaign-button',
};

export const SORTING_QUERY_PARAM = 'rikiavimas';
export const TELIA1_QUERY_PARAM = 'Telia1';

export const PAGE_ID_BY_CHANNEL_OFFER_GROUP = {
    SelfService: {
        MHS: 'mobiliojo-rysio-planai-keisti-plana',
        MBB: 'nesiojamo-interneto-planai-keisti-plana',
    },
    PublicWeb: {
        MHS: 'mobiliojo-rysio-planai',
        MBB: 'nesiojamo-interneto-planai',
    },
} satisfies Partial<Record<Channel, Record<OfferGroup, string>>>;

export const NBO_COMMITMENT = 'NBO';
export const SUPPORTED_COMMITMENTS = [NBO_COMMITMENT, '006', '012', '024', '036', '999'] as const;
export const SERVICE_CHECKOUT_URL = `/{segmentSlug}/uzsakymas/duomenys`;
export const SS_DASHBOARD_URL = `/mano/{segmentSlug}/apzvalga`;
export const SS_CONTACT_SETTINGS_URL = `/mano/{segmentSlug}/kontaktai-ir-privatumas`;
export const SS_CHECKOUT_SEGMENTS = {
    MY: 'mano',
    SERVICES: 'paslaugos',
    CHANGE_PLAN: 'keisti-plana',
    UNIQUE_ORDER: 'uzsakymas-unikalus',
};

export const CREATE_CART_ERROR_KEYS_MAP = {
    [ErrorCode.CartOrderInProgress]: 'ss.rate_plan_change.unavailable.notification.text.plan_changing',
    [ErrorCode.CartSubscriptionChargeLimitExceeded]: 'ss.rate_plan_change.unavailable.notification.text.credit_limit',
    [ErrorCode.CartSubscriptionUnpaid]: 'ss.rate_plan_change.unavailable.notification.text.debt',
    [ErrorCode.CartSubscriptionBlockedByCustomer]: 'ss.rate_plan_change.unavailable.notification.text.loss',
    [ErrorCode.CartSubscriptionSuspended]: 'ss.rate_plan_change.unavailable.notification.text.temporary_suspended',
    [ErrorCode.CartSubscriptionSimCardLocking]: 'ss.rate_plan_change.unavailable.notification.text.sim_card_blocking',
    [ErrorCode.CartSubscriptionSimCardUnlocking]:
        'ss.rate_plan_change.unavailable.notification.text.sim_card_unblocking',
    [ErrorCode.CartBillsOverdue]: 'ss.rate_plan_change.unavailable.notification.text.overdue',
    [ErrorCode.CartContactPhoneMissing]: 'ss.rate_plan_change.unavailable.notification.text.missing_phone',
};
